<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- Modal Mode -->
<div
  *ngIf="isOpen && mode === 'modal'"
  class="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 animate-[fadeIn_0.2s_ease-out]"
  (click)="close()"
>
  <div
    class="bg-white rounded-2xl overflow-hidden w-full max-w-6xl h-[90vh] relative flex flex-col shadow-2xl animate-[scaleIn_0.3s_ease-out]"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div
      class="flex justify-between items-center px-4 py-3 border-b border-neutral-200 bg-gradient-to-r from-neutral-50 to-white"
    >
      <div class="flex items-center gap-3 flex-1 min-w-0">
        <div
          class="flex items-center justify-center w-10 h-10 rounded-lg bg-primary-100 text-primary-600"
        >
          <mat-icon class="!text-[20px] !w-5 !h-5">{{ getFileIcon() }}</mat-icon>
        </div>
        <div class="flex-1 min-w-0">
          <h3 class="font-semibold text-base text-neutral-900 truncate">{{ file?.title || file?.name }}</h3>
          <p class="text-xs text-neutral-500">
            <span *ngIf="file?.description">{{ file?.description }} • </span>{{ getFileSize() }} • {{ fileType }}
          </p>
        </div>
      </div>
      <button
        (click)="close()"
        class="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-red-50 text-neutral-600 hover:text-red-600 transition-colors"
        title="Close"
      >
        <mat-icon class="!text-[20px] !w-5 !h-5">close</mat-icon>
      </button>
    </div>

    <div
      *ngIf="fileType === 'image' && showActions"
      class="flex items-center justify-center gap-1 px-4 py-2 border-b border-neutral-200 bg-neutral-50"
    >
      <button
        (click)="zoomOut()"
        [disabled]="zoomLevel <= 50"
        class="p-2 rounded-lg hover:bg-white disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        title="Zoom Out"
      >
        <mat-icon class="!text-[18px] !w-4.5 !h-4.5">zoom_out</mat-icon>
      </button>
      <button
        (click)="resetZoom()"
        class="px-3 py-1.5 text-xs font-medium rounded-lg hover:bg-white transition-colors"
        title="Reset"
      >
        {{ zoomLevel }}%
      </button>
      <button
        (click)="zoomIn()"
        [disabled]="zoomLevel >= 200"
        class="p-2 rounded-lg hover:bg-white disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        title="Zoom In"
      >
        <mat-icon class="!text-[18px] !w-4.5 !h-4.5">zoom_in</mat-icon>
      </button>
      <div class="w-px h-6 bg-neutral-300 mx-1"></div>
      <button
        (click)="rotateCounterClockwise()"
        class="p-2 rounded-lg hover:bg-white transition-colors"
        title="Rotate Left"
      >
        <mat-icon class="!text-[18px] !w-4.5 !h-4.5">rotate_left</mat-icon>
      </button>
      <button
        (click)="rotateClockwise()"
        class="p-2 rounded-lg hover:bg-white transition-colors"
        title="Rotate Right"
      >
        <mat-icon class="!text-[18px] !w-4.5 !h-4.5">rotate_right</mat-icon>
      </button>
    </div>

    <!-- Content Area -->
    <div class="flex-1 overflow-auto bg-neutral-100 relative">
      <!-- Loading State -->
      <div
        *ngIf="isLoading"
        class="absolute inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-10"
      >
        <div class="flex flex-col items-center gap-3">
          <div
            class="w-12 h-12 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin"
          ></div>
          <p class="text-sm font-medium text-neutral-600">Loading preview...</p>
        </div>
      </div>

      <!-- Error State -->
      <div *ngIf="hasError" class="absolute inset-0 flex items-center justify-center p-8">
        <div class="text-center max-w-md">
          <div
            class="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-red-100"
          >
            <mat-icon class="!text-[32px] !w-8 !h-8 text-red-600">error_outline</mat-icon>
          </div>
          <h4 class="text-lg font-semibold text-neutral-900 mb-2">Preview Not Available</h4>
          <p class="text-sm text-neutral-600 mb-4">{{ errorMessage }}</p>
          <button
            (click)="downloadFile()"
            class="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          >
            <mat-icon class="!text-[18px] !w-4.5 !h-4.5">download</mat-icon>
            Download File
          </button>
        </div>
      </div>

      <!-- Image Preview -->
      <div
        *ngIf="!isLoading && !hasError && fileType === 'image'"
        class="absolute inset-0 flex items-center justify-center p-4 overflow-auto"
      >
        <img
          [src]="safeUrl"
          [alt]="file?.name"
          (load)="onImageLoad()"
          (error)="onImageError()"
          class="max-w-full max-h-full object-contain shadow-2xl transition-transform duration-300"
          [style.transform]="'scale(' + zoomLevel / 100 + ') rotate(' + rotation + 'deg)'"
        />
      </div>

      <!-- PDF Preview -->
      <div
        *ngIf="!isLoading && !hasError && fileType === 'pdf'"
        class="absolute inset-0 flex flex-col bg-neutral-100"
      >
        <embed
          [src]="safeUrl"
          type="application/pdf"
          (load)="onIframeLoad()"
          class="w-full h-full border-0"
          title="PDF Preview"
        />

        <div class="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-10">
          <div class="bg-white rounded-lg shadow-lg px-4 py-3 flex items-center gap-3">
            <span class="text-xs text-neutral-700 font-medium">Can't see the PDF?</span>
            <button
              (click)="openInNewTab()"
              class="inline-flex items-center gap-1 px-3 py-1.5 text-xs bg-primary-600 text-white rounded hover:bg-primary-700 transition-colors"
            >
              <mat-icon class="!text-[14px] !w-3.5 !h-3.5">open_in_new</mat-icon>
              Open in tab
            </button>
            <button
              (click)="downloadFile()"
              class="inline-flex items-center gap-1 px-3 py-1.5 text-xs bg-neutral-600 text-white rounded hover:bg-neutral-700 transition-colors"
            >
              <mat-icon class="!text-[14px] !w-3.5 !h-3.5">file_download</mat-icon>
              Download
            </button>
          </div>
        </div>
      </div>

      <!-- Document Preview -->
      <!-- DOCX Preview -->
      <div
        *ngIf="!isLoading && !hasError && fileType === 'docx'"
        class="absolute inset-0 overflow-auto p-6 bg-white"
      >
        <div #docxContainer class="docx-preview"></div>
      </div>

      <!-- XLSX Preview -->
      <div
        *ngIf="!isLoading && !hasError && fileType === 'xlsx'"
        class="absolute inset-0 overflow-auto p-6 bg-white"
      >
        <div #excelContainer class="excel-preview"></div>
      </div>

      <!-- Video Preview -->
      <div
        *ngIf="!isLoading && !hasError && fileType === 'video'"
        class="absolute inset-0 flex items-center justify-center p-4"
      >
        <video
          [src]="file?.url"
          controls
          class="max-w-full max-h-full rounded-lg shadow-2xl"
          (loadeddata)="onImageLoad()"
        >
          Your browser does not support video playback.
        </video>
      </div>

      <!-- Audio Preview -->
      <div
        *ngIf="!isLoading && !hasError && fileType === 'audio'"
        class="absolute inset-0 flex items-center justify-center p-8"
      >
        <div class="w-full max-w-2xl">
          <div class="bg-white rounded-2xl p-8 shadow-xl">
            <div class="flex items-center gap-4 mb-6">
              <div class="flex items-center justify-center w-16 h-16 rounded-full bg-primary-100">
                <mat-icon class="!text-[32px] !w-8 !h-8 text-primary-600">audiotrack</mat-icon>
              </div>
              <div>
                <h4 class="font-semibold text-lg text-neutral-900">{{ file?.name }}</h4>
                <p class="text-sm text-neutral-500">Audio File</p>
              </div>
            </div>
            <audio [src]="file?.url" controls class="w-full" (loadeddata)="onImageLoad()">
              Your browser does not support audio playback.
            </audio>
          </div>
        </div>
      </div>

      <!-- Unknown Type -->
      <div
        *ngIf="!isLoading && !hasError && fileType === 'unknown'"
        class="absolute inset-0 flex items-center justify-center p-8"
      >
        <div class="text-center max-w-md">
          <div
            class="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-neutral-100"
          >
            <mat-icon class="!text-[32px] !w-8 !h-8 text-neutral-400">insert_drive_file</mat-icon>
          </div>
          <h4 class="text-lg font-semibold text-neutral-900 mb-2">Preview Not Supported</h4>
          <p class="text-sm text-neutral-600 mb-4">
            This file type cannot be previewed in the browser
          </p>
          <button
            (click)="downloadFile()"
            class="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          >
            <mat-icon class="!text-[18px] !w-4.5 !h-4.5">download</mat-icon>
            Download File
          </button>
        </div>
      </div>
    </div>

    <!-- Footer Actions -->
    <div
      *ngIf="showActions"
      class="flex items-center justify-between gap-3 px-4 py-3 border-t border-neutral-200 bg-neutral-50"
    >
      <div class="flex items-center gap-2">
        <button
          *ngIf="showDownload"
          (click)="downloadFile()"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-primary-700 bg-primary-50 hover:bg-primary-100 rounded-lg transition-colors"
        >
          <mat-icon class="!text-[16px] !w-4 !h-4">download</mat-icon>
          Download
        </button>
        <button
          (click)="openInNewTab()"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-neutral-700 hover:bg-neutral-200 rounded-lg transition-colors"
        >
          <mat-icon class="!text-[16px] !w-4 !h-4">open_in_new</mat-icon>
          Open in Tab
        </button>
      </div>
      <button
        (click)="close()"
        class="px-4 py-1.5 text-xs font-medium text-neutral-700 hover:bg-neutral-200 rounded-lg transition-colors"
      >
        Close
      </button>
    </div>
  </div>
</div>

<!-- Inline Mode -->
<div
  *ngIf="mode === 'inline' && file"
  class="inline-preview rounded-lg overflow-hidden border border-neutral-200"
  [style.max-width]="maxWidth"
>
  <!-- Image Inline -->
  <div *ngIf="fileType === 'image'" [style.max-height]="maxHeight" class="relative">
    <img
      [src]="safeUrl"
      [alt]="file.name"
      (load)="onImageLoad()"
      (error)="onImageError()"
      class="w-full h-auto object-cover"
    />
    <div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white/80">
      <div
        class="w-8 h-8 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin"
      ></div>
    </div>
  </div>

  <!-- PDF/Document Inline -->
  <div
    *ngIf="fileType === 'pdf'"
    [style.height]="maxHeight"
    class="relative"
  >
    <iframe [src]="safeUrl" class="w-full h-full border-0"></iframe>
  </div>

  <!-- Unsupported Inline -->
  <div
    *ngIf="fileType !== 'image' && fileType !== 'pdf'"
    class="p-6 bg-neutral-50 text-center"
  >
    <mat-icon class="!text-[40px] !w-10 !h-10 text-neutral-400 mb-2">{{ getFileIcon() }}</mat-icon>
    <p class="text-sm text-neutral-600 mb-3">{{ file.name }}</p>
    <button
      (click)="open(file)"
      class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-primary-700 bg-primary-50 hover:bg-primary-100 rounded-lg transition-colors"
    >
      <mat-icon class="!text-[14px] !w-3.5 !h-3.5">visibility</mat-icon>
      Preview
    </button>
  </div>
</div>

<!-- Thumbnail Mode -->
<div
  *ngIf="mode === 'thumbnail' && file"
  class="thumbnail-preview group relative rounded-lg overflow-hidden border border-neutral-200 hover:border-primary-300 transition-all cursor-pointer hover:shadow-lg"
  (click)="open(file)"
>
  <!-- Image Thumbnail -->
  <div *ngIf="fileType === 'image'" class="relative w-full aspect-square">
    <img
      [src]="safeUrl"
      [alt]="file.name"
      class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
    />
    <div
      class="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center"
    >
      <mat-icon
        class="!text-[32px] !w-8 !h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity"
        >zoom_in</mat-icon
      >
    </div>
  </div>

  <!-- Other Types Thumbnail -->
  <div
    *ngIf="fileType !== 'image'"
    class="relative w-full aspect-square bg-neutral-50 flex flex-col items-center justify-center p-4"
  >
    <mat-icon class="!text-[48px] !w-12 !h-12 text-neutral-400 mb-2">{{ getFileIcon() }}</mat-icon>
    <p class="text-xs text-neutral-600 text-center truncate w-full px-2">{{ file.name }}</p>
  </div>

  <!-- Hover Overlay -->
  <div
    class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity bg-gradient-to-t from-black/60 to-transparent flex items-end p-2"
  >
    <p class="text-xs text-white font-medium truncate w-full">{{ file.name }}</p>
  </div>
</div>
